import { AccordionButton, AccordionIcon, AccordionItem, AccordionPanel, Box, Heading } from "@chakra-ui/react";
import * as React from "react";
import { AnswersVirtualizedList } from "./index";

function QuestionAccordionItem({ question, answers }) {
  return (
    <AccordionItem>
      <h2>
        <AccordionButton>
          <Box flex="1" textAlign="left" justifyContent="center">
            <Heading size="sm">
              {question}
            </Heading>
          </Box>
          <AccordionIcon />
        </AccordionButton>
      </h2>
      <AccordionPanel pt={2} pb={5} overflow="auto">
        <AnswersVirtualizedList
          items={answers}
        />
      </AccordionPanel>
    </AccordionItem>
  )
}

export default QuestionAccordionItem;